import { configureStore } from "@reduxjs/toolkit";
import reducer from "./reducer";
import { socketMiddleware } from "./socketMiddleware";
// ==============================|| REDUX - MAIN STORE ||============================== //

const store = configureStore({
    reducer: reducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(socketMiddleware),
});

export default store;
